import React, { useState } from 'react';
import { CircularProgress, IconButton, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import './RightBar.css';

// Static camera data with video URLs
const camerasData = [
  {
    _id: '1',
    device_name: 'Entrance',
    active: true,
    process_skip_frame: 6,
    zones: { 'Entry Zone': true },
    videoUrl: 'https://drive.google.com/file/d/1ZyMkwNbOBvAjobOcQZjDgavSTPtjlX1v/view'
  },
  {
    _id: '2',
    device_name: 'Help Desk',
    active: true,
    process_skip_frame: 5,
    zones: { 'Help Desk': true },
    videoUrl: 'https://drive.google.com/file/d/1lMyuGjDFPJTThTdoAmMoReXvbc04RMkg/view'
  },
  {
    _id: '3',
    device_name: 'Accessories Zone',
    active: true,
    process_skip_frame: 5,
    zones: { Hallway: true, 'Accessories Zone': true },
    videoUrl: 'https://drive.google.com/file/d/1ZtFdlGhKTv7i7yopmd1Arpu3akyazopK/view'
  },
  {
    _id: '4',
    device_name: 'Mobile Zone',
    active: true,
    process_skip_frame: 5,
    zones: { 'Mobile Zone': true },
    videoUrl: 'https://drive.google.com/file/d/1chJqq5HufZWejPbsA4HFeDXewsXU-tfv/view'
  },
  {
    _id: '5',
    device_name: 'Playstation Zone',
    active: true,
    process_skip_frame: 6,
    zones: { 'Playstation Zone': true },
    videoUrl: 'https://drive.google.com/file/d/12bpF7KrX5c_JhsRBV6YkUTYAbENd3iLM/view'
  },
  {
    _id: '6',
    device_name: 'Laptop Zone',
    active: true,
    process_skip_frame: 6,
    zones: { 'Laptop Zone': true },
    videoUrl: 'https://drive.google.com/file/d/1YQdiWAs51LxJOcXT8vMStbfp4XkYeQY7/view'
  }
];

const CameraCard = ({ camera }) => {
  const dispatch = useDispatch();
  const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
  const isSelected = selectedCamera && selectedCamera._id === camera._id;

  return (
    <div
      className={`flex flex-col bg-white rounded-lg shadow-lg text-xs mb-2.5 p-4 relative hover:shadow-lg transition-all ${
        isSelected ? 'border-2 border-blue-500 bg-blue-50' : ''
      } ${!camera.active ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'}`}
      onClick={(e) => {
        if (!camera.active) {
          e.preventDefault();
          return;
        }
        dispatch({
          type: 'CAMERA_DATA',
          cameraData: { ...camera, streamUrl: camera.videoUrl }
        });
        dispatch({ type: 'VIDEO_PLAYING', videoPlaying: true });
      }}
    >
      <div className="absolute top-2 right-2 flex gap-2">
        <IconButton size="small" disabled={true} className="text-gray-300">
          <EditRoundedIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" disabled={true} className="text-gray-300">
          <DeleteForeverRoundedIcon fontSize="small" />
        </IconButton>
      </div>

      <div className="flex flex-col flex-grow mt-4">
        <div className="mb-2">
          <span className="text-gray-500 text-xs block mb-1">Name:</span>
          <h2 className="text-xl font-semibold">{camera.device_name}</h2>
        </div>

        <div className="mb-2">
          <span className="text-gray-500 text-xs block mb-1">Status:</span>
          <div className="flex items-center gap-2">
            <span className={`px-2 py-1 rounded-full text-xs ${camera.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
              {camera.active ? 'Active' : 'Inactive'}
            </span>
            <span className="text-gray-500 text-xs">Skip Frames: {camera.process_skip_frame}</span>
          </div>
        </div>

        <div>
          <span className="text-gray-500 text-xs block mb-1">Zones:</span>
          <div className="flex flex-wrap gap-2">
            {Object.keys(camera.zones || {}).map((zoneName) => (
              <span key={zoneName} className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                {zoneName}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// eslint-disable-next-line
const RightBar = () => {
  const [loading] = useState(false);
  const [error] = useState(null);

  return (
    <div className="bg-slate-100 border border-gray-300 w-full rounded-lg sticky top-[95px]" style={{ height: 'calc(100vh - 106px)', overflow: 'hidden' }}>
      <div className="p-4" style={{ height: '100%', overflowY: 'auto' }}>
        <div className="flex justify-between items-center mb-4">
          <Typography variant="h5" className="font-medium">
            Cameras
          </Typography>
        </div>
        <div className="space-y-4">
          {loading ? (
            <div className="flex justify-center items-center h-full">
              <CircularProgress />
            </div>
          ) : error ? (
            <div className="flex justify-center items-center h-full">
              <Typography variant="body1" color="error">
                {error}
              </Typography>
            </div>
          ) : camerasData.length === 0 ? (
            <div className="flex justify-center items-center h-full">
              <Typography variant="body1" color="textSecondary">
                No cameras found
              </Typography>
            </div>
          ) : (
            camerasData
              .slice()
              .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
              .map((camera) => <CameraCard key={camera._id} camera={camera} />)
          )}
        </div>
      </div>
    </div>
  );
};

export default RightBar;
